export default {
    FETCH_CONTRACTOR_HISTORY: 'fetchContractorHistory',
    RESET_CONTRACTOR_HISTORY: 'resetContractorHistory',
    REFRESH_CONTRACTOR_HISTORY: 'refreshContractorsHistory',
    CHECK_IF_CONNECTED: 'checkIfConnected',
    DELETE_CONNECTED: 'deleteConnected',
    CHECK_CAN_CONNECT : 'checkCanConnect',
    DELETE_LOCKS : 'deleteLocks',
}
